import { graphql, PageProps } from "gatsby";
import { FC } from "react";
import Category from "src/components/Category";

import { CategoryPageContextType } from "./types";

const FirstCategory: FC<
  PageProps<Gatsby.FirstCategoryQuery> & CategoryPageContextType
> = ({
  pageContext: { pageIndex, upperCategories, subCategories, totalPages, pagePath },
  data: { datoCmsCategory, allDatoCmsArticle },
}) => {
  if (!datoCmsCategory || !allDatoCmsArticle) return null;

  return (
    <Category
      articles={[...allDatoCmsArticle.nodes]}
      category={datoCmsCategory}
      categoryTitle={datoCmsCategory.name!}
      hotjar={datoCmsCategory.hotjar}
      pageIndex={pageIndex!}
      path={pagePath!}
      seo={datoCmsCategory.seo!}
      subCategories={subCategories!}
      totalPages={totalPages!}
      upperCategories={upperCategories!}
    />
  );
};

export default FirstCategory;

export const query = graphql`
  query FirstCategory($id: String, $currentCategoryArticles: [String!], $skip: Int!, $limit: Int!) {
    datoCmsCategory(id: { eq: $id }) {
      ...FirstCategoryData
    }
    allDatoCmsArticle(
      filter: { id: { in: $currentCategoryArticles } }
      sort: { fields: meta___firstPublishedAt, order: DESC }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        ...DatoCmsArticleCard
      }
    }
  }
`;
